import { Box, Button, Typography } from "@mui/material";
import Heading from "../components/Heading";

interface IProps {
  goToGuestCheckout: () => void;
}

const NoAccount: React.FC<IProps> = ({ goToGuestCheckout }) => {
  return (
    <Box textAlign={{ xs: "center", md: "start" }}>
      <Heading title="No account yet?" mb={{ xs: 2, md: 1 }} />
      <Typography
        variant="subtitle1"
        color="text.secondary"
        mb={{ xs: 4, md: 5.25 }}
      >
        If you're new here or prefer a quicker process, feel free to continue as
        a guest.
      </Typography>

      <Box sx={{ "& button": { border: "1px solid #D0D5DD" } }}>
        <Button
          variant="soft"
          fullWidth
          color="secondary"
          onClick={goToGuestCheckout}
        >
          Checkout as Guest
        </Button>
      </Box>
    </Box>
  );
};

export default NoAccount;
